import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { FeaturesSection } from './components/FeaturesSection';
import { HowItWorks } from './components/HowItWorks';
import { Testimonials } from './components/Testimonials';
import { PricingCTA } from './components/PricingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="w-full min-h-screen bg-white" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <FeaturesSection data-id="element-3" />
      <HowItWorks data-id="element-4" />
      <Testimonials data-id="element-5" />
      <PricingCTA data-id="element-6" />
      <Footer data-id="element-7" />
    </main>;
}